import React from 'react';
import Label from '../../atoms/Label';
import IconButton from '../../atoms/IconButton';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { AppState } from '../../../redux/modules/store';

interface SideNavItemProps {
  selectedStoreName: string;
  onclick: (isOpen: boolean) => void;
}

const loadingLabel = '参照可能店舗取得中';

const SelectStoreName: React.FC<SideNavItemProps> = ({ selectedStoreName, onclick }) => {
  const { isLoading } = useSelector((state: AppState) => state.loadingStatus.fetchVisitReservationStoreList);
  const label = isLoading ? loadingLabel : selectedStoreName;

  const handleClickStoreNamePulldown = () => {
    !isLoading && onclick(true);
  };

  return (
    <div className='u-pr16'>
      <div
        className={classNames('visit-store-select uc-select uc-select--w-full', { 'u-pointer-events-none': isLoading })}
        data-testid='select-store-name--event'
        onClick={handleClickStoreNamePulldown}>
        <Label className='visit-store-select__text' label={label} data-testid='select-store-name--label' />
        {isLoading && (
          <IconButton
            data-testid='select-store-name--loading-icon'
            data-testid-e2e='select-store-name--loading-icon'
            className={classNames('icon-button--rotate')}
            disabled={isLoading}
            icon='autorenew'
          />
        )}
      </div>
    </div>
  );
};

export default SelectStoreName;
